import { Feature } from '@ngb-frontend/shared/types'

import type { FlowConfig } from '@ngb-frontend/shared/types'

/**
 * The step a session opens on: editing an existing booking (bookingId in the
 * query) skips the driver dashboard, which only starts new requests.
 */
export const getEntryStep = (
  { type, steps }: FlowConfig<Feature>,
  bookingId?: string | null,
) => (type === Feature.MnR && bookingId ? steps[1] : steps[0])
